<template>
	<v-container>
		<v-row justify="center" align="center">
			<v-col cols="12" sm="10" md="8" lg="6">
		 		<v-card>
			  	<v-tabs
			      v-model="tab"
			      background-color="transparent"
			      grow
			    >
			      <v-tab
			      	v-for="item in items"
			        :key="item"
			      >
			        {{ $t("settings."+item+".title") }}
			      </v-tab>
			    </v-tabs>

			    <v-tabs-items v-model="tab">
			    	<!-- Change Email -->
			      <v-tab-item>
			      	<ChangeEmail/>
			      </v-tab-item>
			      <!-- Change Password -->
			      <v-tab-item>
			        <ChangePassword/>
			      </v-tab-item>
			    </v-tabs-items>
				</v-card>
	    </v-col>

		</v-row>
	</v-container>
</template>

<script>

import ChangeEmail from '@/components/settings/changeEmail.vue'
import ChangePassword from '@/components/settings/changePassword.vue'

export default {
  name: 'Settings',
  components: {
    ChangeEmail,
    ChangePassword
  },
  data(){
  	return {
  		tab: null,
      items: [
      	//Translation keys
        'changeEmail', 'changePassword',
      ]
    }
  }
};
</script>
